import { render } from "./KOLBlockPage.vue?vue&type=template&id=76f9eb62&scoped=true"
import script from "./KOLBlockPage.vue?vue&type=script&lang=js"
export * from "./KOLBlockPage.vue?vue&type=script&lang=js"

import "./KOLBlockPage.vue?vue&type=style&index=0&id=76f9eb62&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3141391227/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f9eb62"]])

export default __exports__